var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5285 0.532538C9.82389 1.24246 9.82374 2.3938 10.5286 3.1038L27.2977 19.9996L10.5285 36.8961C9.82389 37.6061 9.82374 38.7574 10.5286 39.4674C11.2334 40.1774 12.3759 40.1774 13.0805 39.4674L31.1257 21.2851C31.4641 20.9441 31.6542 20.4818 31.6542 19.9996C31.6542 19.5174 31.4639 19.0549 31.1255 18.7139L13.0805 0.532698C12.3758 -0.177539 11.2332 -0.177539 10.5285 0.532538Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronNext);
export default __webpack_public_path__ + "static/media/chevron-next.bf68a8840227704d1f07790d57840fda.svg";
export { ForwardRef as ReactComponent };